import { Add } from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { HomePageItem } from "./news.interface";
import HomePageForm from "./HomePageForm";
import HomePageItemDisplay from "./HomePageItemDisplay";

export default function HomePage() {

  const [data, setData] = useState<HomePageItem[]>()
  const [form, setForm] = useState<HomePageItem>()

  function find() {
    axios.post('cms/homepage', {}).then(({ data }) => {
      setData(data || [])
    })
  }

  useEffect(find, [])

  function save(i: HomePageItem) {
    axios.post('cms/homepageSave', { ...i, sort: Number(i.sort) }).then(() => {
      setForm(undefined)
      find()
    })
  }

  return <Stack spacing={2} sx={{ mt: 2 }}>

    <Stack direction={"row"} >
      <Box sx={{
        p: 1, border: '1px solid gray',flexShrink:0, width: 300, overflow: 'auto', height: 600, borderRadius: 3,
      }}>
        {data?.map((i, index) => <Stack sx={
          {
            minHeight: '3rem', borderBottom: '1px solid gray', p: 1,
            backgroundColor: form && form._id === i._id ? '#bdbdbd50' : '',
            opacity: i.show ? 1 : .4
          }
        } key={index} onClick={() => {
          setForm({ ...i })
        }}>
          <Stack direction={"row"}>
            <Typography flexGrow={1} variant="caption" sx={{ opacity: .7 }}>{index + 1}.{i.auto
              ? `[自动]${i.where?.channel || ''} ${i.where?.tags || ""} ${i.where?.keyword || ''} ${i.where?.length || 2}条`
              : `[手动]${i.item.length}条`}</Typography>
            <Typography variant="caption">{i.show ? '' : '不显示'}</Typography>
          </Stack>
          <HomePageItemDisplay value={i}></HomePageItemDisplay>
        </Stack>)}
        <Stack direction={"row"}>
          <Button startIcon={<Add />} onClick={() => {
            const sort = Math.max(0, ...(data || []).map((i, index) => i.sort || index)) + 1
            save({ sort, auto: true, show: true, item: [] })
          }}>添加</Button>
        </Stack>
      </Box>
      <Stack flexGrow={1} sx={{ p: 2 }}>
        {form && <HomePageForm news={form} save={save}></HomePageForm>}
      </Stack>
    </Stack>

  </Stack >
}